<div class="content-container mb-3">
  <div class="content">
    <mwp-text-translate text="The resources listed below are required to be presented for you review before you finalize your elections. Please click the links below and review all the the information provided." jsonKey="documentsInstructions" />
  </div>
  <div class="content">
    @if (resourceForm) {
      <form [formGroup]="resourceForm">
        <table mat-table [dataSource]="tableData">
          <div [formArrayName]="documentFormArrayName">
            @for (tableColumn of tableColumns; track $index) {
              <ng-container matColumnDef="{{tableColumn.propertyId}}">
                <th mat-header-cell *matHeaderCellDef class="top-border"
                  [ngStyle]="{'width' : (tableColumn.width) ? (tableColumn.width) : 'auto'}">
                  <div>
                    <mwp-text-translate [text]="tableColumn.columnName" [jsonKey]="tableColumn.columnName" />
                  </div>
                </th>
                <td mat-cell *matCellDef="let element; index as rowIndex" [formGroupName]="rowIndex" >
                  @if (displayElement(tableColumn, columnType.checkBox, element)) {
                    <div>
                      <mat-checkbox [formControlName]="tableColumn.propertyId" [checked]="element[tableColumn.propertyId]">
                        @if (tableColumn.dataTypeText) {
                          <span>{{ findElementByColumnName(element, tableColumn.dataTypeText, tableColumn.textType) }}</span>
                        }
                      </mat-checkbox>
                    </div>
                  }
                  @if (displayElement(tableColumn, columnType.hyperLink, element)) {
                    <div class="d-inline-flex">
                      <a (click)="openLink(element[tableColumn.propertyId])">
                        <span>{{ findElementByColumnName(element, tableColumn.dataTypePropertyId, tableColumn.textType) }}</span>
                      </a>
                    </div>
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="renderdColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: renderdColumns;"></tr>
          </div>
        </table>
      </form>
    }
  </div>
</div>
<div>
  <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="!resourceForm.valid" (emitComplete)="complete()" />
</div>